import { getSvocId, getUserId } from '../utils/user';

const svocId = getSvocId();
const userId = getUserId();

export const B2B_ACCOUNT_PATH = '/b2b/user/account';

// // B2B paths:
export const B2B_ACCOUNT_PATH_WITH_USER_ID = `${B2B_ACCOUNT_PATH}/${userId}`;
export const B2B_ACCOUNT_REWARDS_AND_OFFERS_PATH = `${B2B_ACCOUNT_PATH_WITH_USER_ID}/customer/${svocId}/rewardsandoffers`;
export const B2B_VALIDATE_AGREEMENT_CODE = `${B2B_ACCOUNT_PATH_WITH_USER_ID}/customer/${svocId}/agreement/validate`;
export const B2B_ENROLL_AGREEMENT_CODE = `${B2B_ACCOUNT_PATH_WITH_USER_ID}/customer/${svocId}/agreement?action=ENROLL`;
export const B2B_UNENROLL_AGREEMENT_CODE = `${B2B_ACCOUNT_PATH_WITH_USER_ID}/customer/${svocId}/agreement?action=UNENROLL`;
